import React, { useEffect, useState } from "react";
import DonutChartProfile from "../Layouts/Graphs/DonutChartProfile";
import _ from "lodash";
import { ProgressBar } from "react-bootstrap";
import ShimmerNotification from "../Layouts/ShimmerNotification";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import ShimmerForProfileTabs from "../Layouts/ShimmerForProfileTabs";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { redirectToPageUtil } from "../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";

const ContentDetailComponent = ({
  stats,
  profileReports,
  heading,
  onSearchClicked,
  setSearchText,
  searchText,
  sections,
  isNameAsc,
  setNameOrder,
  isProgressAsc,
  setProgressOrder,
  isStatusAsc,
  setStatusOrder,
  isLoading,
  selectedBox,
  setSelectedBox,
  isOther,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    // if (searchText?.length > 2) {
    //   onSearchClicked();
    // } else
    if (searchText === "") {
      onSearchClicked();
    }
  }, [searchText]);

  let navigate = useNavigate();
  let dispatch = useDispatch();
  const authBroker = useSelector((state) => state.auth.authBroker);
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const tab = params.get("tab");

  const [courseData, setCourseData] = useState({});

  const navigateToDetail = (item) => {
    if (tab === "2" || tab == "3") {
      let itemObj = {
        source: "broker",
        id: item?.id,
        is_paid: true,
        from: "course",
        provider_id: "",
        provider_name: null,
        cname: item?.name,
        status: item?.status,
        product_type: "course",
        crscd: item?.code,
        is_onboarding: "0",
      };
      console.log("itemObj--", itemObj);
      redirectToPageUtil(
        itemObj,
        navigate,
        authBroker,
        setCourseData,
        dispatch,
        "course"
      );
    } else if (tab === "3") {
      console.log("item--", item);
      // let paramsReq = {
      //   code: item?.code,
      //   source: item?.source,
      // };
      // let jsonString = JSON.stringify(paramsReq);
      // let encodedUrl = btoa(jsonString);
      let obj = {
        source: item?.source === "xsel" ? "ecom" : item?.source,
        cid: item?.id,
        from: "course",
      };
      let jsonString = JSON.stringify(obj);
      let encodedUrl = btoa(jsonString);
      let url = `/courseDetail/${item?.code}?c=${encodedUrl}`;

      navigate(url);
    } else if (tab === "8") {
      let paramsReq = {
        lp_id: item?.lp_id,
        is_level: "false",
        source:
          _.lowerCase(item?.source) === "ecom" ||
          _.lowerCase(item?.source) === "xsel"
            ? "xsel"
            : _.lowerCase(item?.source),
      };

      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      navigate(`/lpDetail?c=${encodedUrl}`);
    } else if (tab === "9") {
      let paramsReq = {
        lp_id: item?.lp_id,
        is_level: "false",
        source:
          _.lowerCase(item?.source) === "ecom" ||
          _.lowerCase(item?.source) === "xsel"
            ? "xsel"
            : _.lowerCase(item?.source),
      };

      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      navigate(`/lpDetail?c=${encodedUrl}`);
    }
  };

  // const sections = [
  //   { value: 12, color: "#90989A" }, // gray section
  //   { value: 17, color: "#EF6779" }, // red section
  //   { value: 30, color: "#47C478" }, // green section
  //   { value: 25, color: "#F0A446" }, // orange section
  // ];
  return (
    <div className="profile-info-wrapper">
      <div className="profile-info-title d-flex justify-content-between gap-3 align-items-center flex-wrap">
        <div className="title-box">{heading}</div>
        <div className="search-info">
          <div className="confirm-row m-0">
            <input
              type="search"
              id="search"
              name={t("search")}
              className="form-control"
              placeholder={`${_.toLower(heading)}`}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              disabled={isLoading}
            />
            <button className="confirm-btn" onClick={() => onSearchClicked()}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                  fill="black"
                ></path>
              </svg>
              {t("Search")}
            </button>
          </div>
          {/* <div className="input-text position-relative">
            <label htmlFor="search" className="input__label">
              Search
            </label>
            <input
              type="search"
              id="search"
              name="search"
              className="input_field mr-2"
              placeholder={`${_.toLower(heading)}`}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              disabled={isLoading}
            />
          </div> */}
        </div>
      </div>
      <div className="graph-prolie-info">
        <div className="graph-shpw">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DonutChartProfile
              sections={sections}
              name={heading}
              isLoading={isLoading}
            />
          </div>
        </div>
        <div className="graph-info-boxes">
          {isLoading ? (
            _.toLower(heading) === "videos" ? (
              [0, 1].map((item) => {
                return (
                  <div className="graph-info-wrap">
                    <ShimmerScreen
                      height={"25px"}
                      width={"100%"}
                      case={"rect"}
                    />
                  </div>
                );
              })
            ) : (
              [0, 1, 2, 3].map((item) => {
                return (
                  <div className="graph-info-wrap">
                    <ShimmerScreen
                      height={"25px"}
                      width={"100%"}
                      case={"rect"}
                    />
                  </div>
                );
              })
            )
          ) : (
            <>
              <div
                className={`graph-info-wrap completed cursor-pointer ${
                  selectedBox === "completed" ? "selected" : ""
                }`}
                onClick={() => {
                  if (selectedBox === "completed") {
                    setSelectedBox("all");
                  } else {
                    setSelectedBox("completed");
                  }
                }}
              >
                <div class="icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1907_105660)">
                      <path
                        d="M5.03712 10.4585C4.99523 10.4134 4.95773 10.365 4.9255 10.3148C4.89313 10.2642 4.86486 10.2102 4.84157 10.1541C4.76378 9.96877 4.74269 9.76868 4.7755 9.57781C4.80831 9.38826 4.89445 9.20706 5.03097 9.05808L5.08077 9.00681C5.41666 8.68674 5.92614 8.62712 6.32574 8.86751C6.38287 8.90164 6.43737 8.94221 6.4882 8.98865L6.49318 8.99319C6.77604 9.26448 7.2546 9.70818 7.56881 9.98782L7.83849 10.2297L11.1391 6.7675C11.1855 6.7196 11.2366 6.67668 11.2907 6.63918C11.3461 6.60095 11.4042 6.56858 11.4643 6.54236C11.5249 6.51584 11.5891 6.49504 11.6547 6.48069C11.7202 6.46619 11.787 6.45798 11.8533 6.45652H11.8571C11.9232 6.45579 11.988 6.46047 12.0536 6.47161C12.1176 6.48245 12.1819 6.49988 12.2488 6.52566C12.3105 6.54924 12.3697 6.57883 12.4256 6.61414C12.4791 6.64797 12.5313 6.68826 12.5803 6.73455L12.6041 6.75608C12.6504 6.80193 12.6921 6.85173 12.7286 6.90461C12.7661 6.95867 12.7982 7.01682 12.8241 7.07717C12.8509 7.13782 12.8717 7.20198 12.8862 7.26746C12.9008 7.33176 12.9088 7.39856 12.9104 7.46667V7.50037C12.9098 7.55881 12.9042 7.61814 12.8937 7.67673C12.8821 7.74045 12.8647 7.80315 12.8415 7.86292C12.8181 7.92415 12.788 7.98376 12.7526 8.04016C12.7177 8.09539 12.6767 8.14841 12.6307 8.1969L8.64357 12.3805C8.59669 12.4306 8.54645 12.4745 8.49386 12.512C8.43981 12.5507 8.38151 12.584 8.32057 12.6118C8.25949 12.6393 8.19591 12.6612 8.1319 12.6762C8.06818 12.6915 8.00167 12.7006 7.93414 12.7036L7.91583 12.7041C7.85387 12.7054 7.79279 12.7017 7.73405 12.6927L7.7191 12.6897C7.65831 12.6795 7.59913 12.6642 7.54259 12.6443C7.48092 12.6223 7.42057 12.5941 7.363 12.5601L7.35377 12.5542C7.29943 12.5214 7.24874 12.4844 7.2026 12.4438L7.19337 12.435C6.96193 12.2202 6.71041 12.0017 6.45612 11.7808C6.01564 11.398 5.40465 10.8459 5.03844 10.4595L5.03712 10.4585ZM8.99982 0.499878C11.4842 0.499878 13.7354 1.50813 15.365 3.13469C16.9916 4.76433 17.9997 7.0155 17.9997 9.49988C17.9997 11.9844 16.9914 14.2356 15.365 15.8652C13.7355 17.4918 11.4842 18.4999 8.99982 18.4999C6.5153 18.4999 4.26412 17.4918 2.63448 15.8652C1.00792 14.2356 -0.000183105 11.9843 -0.000183105 9.49973C-0.000183105 7.0155 1.00792 4.76433 2.63448 3.13469C4.26427 1.50813 6.5153 0.499878 8.99982 0.499878ZM14.194 4.30569C12.865 2.97649 11.0286 2.15457 8.99982 2.15457C6.97086 2.15457 5.13453 2.97649 3.80548 4.30569C2.47643 5.63474 1.6545 7.47107 1.6545 9.49973C1.6545 11.5287 2.47643 13.365 3.80548 14.6941C5.13453 16.0231 6.97086 16.8452 8.99982 16.8452C11.0286 16.8452 12.865 16.0233 14.194 14.6941C15.5231 13.3649 16.345 11.5287 16.345 9.49973C16.345 7.47107 15.5232 5.63474 14.194 4.30569Z"
                        fill="#6BBE66"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1907_105660">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(-0.000183105 0.499878)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                {stats?.completed} {t("completed")}
              </div>

              <div
                className={`graph-info-wrap yt-start cursor-pointer ${
                  selectedBox === "yt-start" ? "selected" : ""
                }`}
                onClick={() => {
                  if (selectedBox === "yt-start") {
                    setSelectedBox("all");
                  } else {
                    setSelectedBox("yt-start");
                  }
                }}
              >
                <div class="icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1907_105674)">
                      <path
                        d="M14.8887 2.66356C14.8078 2.57974 14.7108 2.51307 14.6036 2.46754C14.4964 2.42201 14.3811 2.39854 14.2646 2.39854C14.1481 2.39854 14.0329 2.42201 13.9256 2.46754C13.8184 2.51307 13.7215 2.57974 13.6406 2.66356L12.6899 3.61131C12.4321 3.44503 12.1624 3.29815 11.8828 3.17186C11.6021 3.04626 11.3146 2.9367 11.0215 2.84373V1.37889C11.0241 1.26295 11.0028 1.14772 10.9589 1.04037C10.9151 0.933013 10.8496 0.83583 10.7666 0.754865C10.6857 0.671773 10.5885 0.606255 10.4811 0.562401C10.3738 0.518546 10.2585 0.497298 10.1426 0.499982H8.31297C8.19858 0.499095 8.08517 0.521199 7.97948 0.564983C7.8738 0.608768 7.77799 0.673339 7.69774 0.754865C7.61366 0.835325 7.5471 0.932281 7.50223 1.03966C7.45736 1.14704 7.43515 1.26253 7.43699 1.37889V2.71336C7.13487 2.78435 6.83821 2.87687 6.5493 2.99022C6.26811 3.09751 5.99453 3.22378 5.73045 3.36815L4.67723 2.32957C4.60022 2.24485 4.50604 2.17751 4.40097 2.13204C4.29589 2.08658 4.18233 2.06403 4.06785 2.0659C3.95142 2.06539 3.83609 2.08849 3.72883 2.13381C3.62157 2.17913 3.52462 2.24573 3.44383 2.32957L2.16356 3.61424C2.07974 3.69512 2.01307 3.79207 1.96754 3.89928C1.92201 4.00649 1.89854 4.12178 1.89854 4.23826C1.89854 4.35474 1.92201 4.47003 1.96754 4.57725C2.01307 4.68446 2.07974 4.7814 2.16356 4.86229L3.11131 5.81297C2.94503 6.07076 2.79815 6.34054 2.67186 6.6201C2.54574 6.89955 2.43617 7.18617 2.34373 7.4785H0.878888C0.762953 7.4759 0.647723 7.49719 0.540368 7.54104C0.433013 7.58489 0.33583 7.65036 0.254865 7.73338C0.171773 7.81429 0.106255 7.91147 0.0624005 8.01883C0.0185462 8.1262 -0.00270227 8.24146 -1.81287e-05 8.3574V10.187C-0.000905351 10.3014 0.0211992 10.4148 0.0649835 10.5205C0.108768 10.6262 0.173339 10.722 0.254865 10.8022C0.335106 10.8866 0.432023 10.9533 0.539453 10.9982C0.646883 11.0431 0.762478 11.0652 0.878888 11.063H2.21483C2.28533 11.3651 2.37736 11.6617 2.49022 11.9507C2.60063 12.2367 2.7268 12.5164 2.86815 12.7886L1.82664 13.8301C1.74192 13.9071 1.67458 14.0012 1.62911 14.1063C1.58365 14.2114 1.5611 14.325 1.56297 14.4394C1.56246 14.5559 1.58556 14.6712 1.63088 14.7785C1.6762 14.8857 1.7428 14.9827 1.82664 15.0635L3.11131 16.3628C3.2806 16.5209 3.50365 16.6089 3.73533 16.6089C3.96702 16.6089 4.19006 16.5209 4.35936 16.3628L5.31004 15.3974C5.56832 15.5629 5.83804 15.7097 6.11717 15.8369C6.39792 15.9648 6.68546 16.0773 6.9785 16.1738V17.6313C6.97732 17.7471 6.99925 17.8619 7.04301 17.9691C7.08676 18.0762 7.15145 18.1736 7.2333 18.2554C7.31515 18.3373 7.41251 18.402 7.51968 18.4457C7.62684 18.4895 7.74166 18.5114 7.8574 18.5102H9.68699C9.80139 18.5111 9.91479 18.489 10.0205 18.4452C10.1262 18.4014 10.222 18.3369 10.3022 18.2554C10.3866 18.1751 10.4533 18.0782 10.4982 17.9708C10.5431 17.8633 10.5652 17.7477 10.563 17.6313V16.2969C10.865 16.2268 11.1617 16.1353 11.4507 16.0229C11.737 15.9131 12.0167 15.7869 12.2886 15.645L13.3301 16.6733C13.4097 16.7567 13.5054 16.8231 13.6114 16.8685C13.7174 16.9138 13.8315 16.9372 13.9468 16.9372C14.0621 16.9372 14.1762 16.9138 14.2822 16.8685C14.3882 16.8231 14.4839 16.7567 14.5635 16.6733L15.8628 15.3901C16.021 15.2206 16.1091 14.9973 16.1091 14.7654C16.1091 14.5334 16.021 14.3101 15.8628 14.1406L14.896 13.1899C15.0623 12.9321 15.2091 12.6624 15.3354 12.3828C15.4634 12.102 15.5758 11.8145 15.6723 11.5215H17.1299C17.2456 11.5226 17.3604 11.5007 17.4676 11.457C17.5748 11.4132 17.6721 11.3485 17.754 11.2667C17.8358 11.1848 17.9005 11.0875 17.9443 10.9803C17.988 10.8731 18.0099 10.7583 18.0088 10.6426V8.81297C18.0097 8.69858 17.9876 8.58517 17.9438 8.47948C17.9 8.3738 17.8354 8.27799 17.7539 8.19774C17.6736 8.11337 17.5767 8.04662 17.4693 8.00173C17.3619 7.95684 17.2463 7.9348 17.1299 7.93699H15.7954C15.7219 7.63875 15.6305 7.34525 15.5215 7.05809C15.415 6.77323 15.2887 6.49618 15.1435 6.22899L16.1821 5.17723C16.2668 5.10022 16.3342 5.00604 16.3796 4.90097C16.4251 4.79589 16.4477 4.68233 16.4458 4.56785C16.4463 4.45142 16.4232 4.33609 16.3779 4.22883C16.3326 4.12157 16.266 4.02462 16.1821 3.94383L14.8974 2.66356H14.8887ZM8.99998 4.1284C10.242 4.12803 11.4457 4.55829 12.406 5.34589C13.3664 6.13348 14.0239 7.22968 14.2667 8.44772C14.5094 9.66576 14.3224 10.9303 13.7373 12.0259C13.1523 13.1215 12.2055 13.9803 11.0583 14.4561C9.91105 14.9319 8.63433 14.9952 7.44563 14.6353C6.25694 14.2753 5.22982 13.5144 4.53927 12.482C3.84871 11.4497 3.53744 10.2099 3.65849 8.97382C3.77953 7.73774 4.32541 6.58186 5.20311 5.70311C5.70128 5.20397 6.29316 4.80817 6.94474 4.53844C7.59633 4.26871 8.29478 4.13036 8.99998 4.13133V4.1284Z"
                        fill="#A6ABAE"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.99902 5.31445C9.8271 5.31445 10.6366 5.56003 11.3251 6.02011C12.0136 6.4802 12.5502 7.13413 12.867 7.8992C13.1838 8.66427 13.2667 9.50612 13.105 10.3183C12.9433 11.1304 12.5445 11.8764 11.9588 12.4618C11.3732 13.0473 10.6271 13.4459 9.81488 13.6072C9.00267 13.7686 8.16086 13.6855 7.3959 13.3684C6.63093 13.0513 5.97719 12.5145 5.51734 11.8258C5.0575 11.1372 4.81221 10.3276 4.8125 9.49951C4.8125 8.9498 4.9208 8.40547 5.13121 7.89762C5.34162 7.38977 5.65002 6.92835 6.03879 6.53971C6.42757 6.15107 6.8891 5.84283 7.39702 5.6326C7.90494 5.42237 8.44931 5.31426 8.99902 5.31445ZM7.11377 8.65137C6.95703 8.50488 6.83105 8.40088 7.02734 8.21191L7.66016 7.59522C7.86084 7.3916 7.97803 7.40186 8.16406 7.59522L9.0166 8.44775L9.86475 7.59961C10.0186 7.44287 10.1152 7.31836 10.3042 7.51465L10.9209 8.146C11.1245 8.34668 11.1143 8.46387 10.9209 8.65137L10.0698 9.50244L10.9209 10.355C11.1128 10.541 11.123 10.6582 10.9209 10.8589L10.3057 11.4858C10.1152 11.6807 10.0127 11.5562 9.86621 11.3994L9.01807 10.5513L8.16553 11.4038C7.97949 11.5957 7.86231 11.606 7.66162 11.4038L7.03027 10.7886C6.83398 10.5981 6.95996 10.4956 7.1167 10.3491L7.96484 9.50098L7.1167 8.65283L7.11377 8.65137Z"
                        fill="#575557"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1907_105674">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>{" "}
                {stats?.notStarted} {t("yetToStart")}
              </div>
              {_.toLower(heading) === "videos" && false ? (
                ""
              ) : (
                <>
                  {" "}
                  <div
                    className={`graph-info-wrap inprogress cursor-pointer ${
                      selectedBox === "inprogress" ? "selected" : ""
                    }`}
                    onClick={() => {
                      if (selectedBox === "inprogress") {
                        setSelectedBox("all");
                      } else {
                        setSelectedBox("inprogress");
                      }
                    }}
                  >
                    <div class="icon">
                      <svg
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1907_105667)">
                          <path
                            d="M7.38366 6.1409C7.38366 5.62838 7.79901 5.21268 8.31153 5.21268C8.82406 5.21268 9.23941 5.62838 9.23941 6.1409V10.0306L11.8122 11.1616C12.2809 11.3678 12.4934 11.9147 12.2872 12.3831C12.0809 12.8514 11.534 13.064 11.0657 12.8581L7.98564 11.504C7.63378 11.3721 7.38366 11.0328 7.38366 10.635V6.1409ZM0.189416 6.41242C0.162755 6.33349 0.146267 6.24965 0.141707 6.1623L0.00138595 3.58425C-0.0249242 3.07384 0.367974 2.63884 0.878391 2.61288C1.38881 2.58657 1.8238 2.97947 1.84976 3.48989L1.87572 3.96698C2.25802 3.47502 2.69082 3.02447 3.16702 2.62271C3.79741 2.09089 4.5134 1.6373 5.30727 1.28334C7.5759 0.27128 10.0378 0.273736 12.1837 1.09566C14.3078 1.90953 16.1253 3.52567 17.144 5.75537C17.171 5.80378 17.1938 5.85499 17.2121 5.90832C18.1894 8.15555 18.1778 10.5856 17.3654 12.7072C16.5515 14.8313 14.9354 16.6488 12.7057 17.6672C12.5676 17.7446 12.4118 17.7851 12.2535 17.7847C11.741 17.7847 11.3256 17.3694 11.3256 16.8568C11.3256 16.4534 11.5831 16.1103 11.9427 15.9826C12.2125 15.8588 12.471 15.7206 12.7176 15.5687C12.7457 15.5455 12.7755 15.5238 12.8071 15.5035C13.2045 15.2467 13.5823 14.9527 13.924 14.625C13.9465 14.6036 13.97 14.5833 13.9942 14.5647C14.7189 13.8456 15.2739 12.984 15.6328 12.0474C16.2874 10.3389 16.2912 8.38287 15.4889 6.58466L15.4886 6.58361C14.6863 4.7854 13.2298 3.48182 11.5238 2.82828C9.81542 2.17403 7.85935 2.17017 6.06114 2.9721C5.448 3.24523 4.87642 3.60341 4.36326 4.03609C4.01737 4.32795 3.70375 4.64859 3.42486 4.99343L3.54589 4.97834C4.0542 4.91625 4.51691 5.27828 4.579 5.78659C4.64109 6.2949 4.27907 6.75761 3.77075 6.8197L1.20779 7.13542C0.728598 7.19366 0.290096 6.87548 0.189416 6.41242ZM9.94487 18.4435C10.6773 18.3614 11.0267 17.4988 10.5574 16.9295C10.3571 16.6864 10.0526 16.5667 9.74035 16.599C9.1945 16.6604 8.6483 16.6593 8.10281 16.5944C7.77516 16.5555 7.45558 16.6899 7.25422 16.9512C6.82063 17.5276 7.16476 18.3464 7.87935 18.4369C8.56622 18.5189 9.2573 18.5207 9.94487 18.4435ZM4.02544 17.0168C4.30327 17.2013 4.64881 17.2224 4.94875 17.0779C5.59036 16.76 5.6493 15.8707 5.05434 15.4726C4.60496 15.1762 4.17242 14.8075 3.80513 14.4146C3.46906 14.0567 2.9183 14.0199 2.53839 14.3307C2.44027 14.4112 2.3597 14.5109 2.30166 14.6237C2.24362 14.7365 2.20935 14.86 2.20096 14.9866C2.19258 15.1132 2.21026 15.2402 2.25291 15.3597C2.29556 15.4792 2.36228 15.5886 2.44893 15.6813C2.9169 16.1794 3.45433 16.6404 4.02544 17.0168ZM0.383409 12.1456C0.485843 12.4767 0.759469 12.7181 1.0994 12.7833C1.78486 12.9107 2.36263 12.2627 2.15636 11.5969C1.99289 11.0707 1.89361 10.5354 1.85327 9.98569C1.80556 9.34267 1.1443 8.94661 0.553197 9.20235C0.192924 9.36547 -0.0242226 9.72118 0.00208755 10.1169C0.0519014 10.8066 0.17819 11.485 0.383409 12.1456Z"
                            fill="#F0A446"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1907_105667">
                            <rect
                              width="17.9611"
                              height="18"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>{" "}
                    {stats?.inprogress} {t("inProgress")}
                  </div>
                  {false && (
                    <div
                      className={`graph-info-wrap overdue cursor-pointer ${
                        selectedBox === "overdue" ? "selected" : ""
                      }`}
                      onClick={() => {
                        if (selectedBox === "overdue") {
                          setSelectedBox("all");
                        } else {
                          setSelectedBox("overdue");
                        }
                      }}
                    >
                      <div class="icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 22 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_1907_105681)">
                            <path
                              d="M12.9862 0.5C14.2029 0.5 15.3659 0.74334 16.427 1.18171C17.5291 1.63797 18.5204 2.30716 19.3488 3.13559C20.1773 3.96402 20.8464 4.95527 21.3027 6.05924C21.7429 7.12028 21.9844 8.2833 21.9844 9.5C21.9844 10.7167 21.7411 11.8797 21.3027 12.9408C20.8464 14.0429 20.1773 15.0342 19.3488 15.8626C18.5204 16.6911 17.5291 17.3602 16.4252 17.8165C15.3641 18.2567 14.2011 18.4982 12.9844 18.4982C11.7677 18.4982 10.6047 18.2549 9.54365 17.8165C8.44326 17.3602 7.452 16.6928 6.62178 15.8626L6.62 15.8608C5.78978 15.0306 5.12238 14.0412 4.66612 12.939C4.52477 12.5972 4.4031 12.2465 4.30469 11.8851C4.49256 11.903 4.68401 11.9119 4.87725 11.9119C5.24405 11.9119 5.6019 11.8779 5.95081 11.8153C6.00807 11.9889 6.07069 12.1606 6.14047 12.3288C6.51443 13.2324 7.06552 14.0465 7.74902 14.7318C8.43252 15.4153 9.24843 15.9664 10.152 16.3404C11.0234 16.7018 11.9788 16.9004 12.9844 16.9004C13.99 16.9004 14.9454 16.7018 15.8168 16.3404C16.7204 15.9664 17.5345 15.4153 18.2198 14.7318C18.9033 14.0483 19.4544 13.2324 19.8283 12.3288C20.1898 11.4575 20.3884 10.502 20.3884 9.49642C20.3884 8.49086 20.1898 7.53539 19.8283 6.66402C19.4544 5.76044 18.9033 4.94632 18.2198 4.26103C17.5363 3.57754 16.7204 3.02644 15.8168 2.65249C14.9454 2.29105 13.99 2.09245 12.9844 2.09245C11.9788 2.09245 11.0234 2.29105 10.152 2.65249C10.0733 2.68469 9.99634 2.71869 9.9194 2.75268C9.62417 2.28569 9.26453 1.86342 8.85479 1.49662C9.07845 1.38032 9.30747 1.27475 9.54186 1.17634C10.6065 0.74334 11.7695 0.5 12.9862 0.5ZM11.952 5.22187C11.952 5.00179 12.0415 4.80139 12.1864 4.65646C12.3313 4.51153 12.5317 4.42207 12.7518 4.42207C12.9719 4.42207 13.1723 4.51153 13.3172 4.65646C13.4621 4.80139 13.5516 5.00179 13.5516 5.22187V9.42127L16.69 11.2821C16.8778 11.393 17.0049 11.572 17.0568 11.7706C17.1069 11.9674 17.0836 12.1839 16.9727 12.3736V12.3753C16.8617 12.5632 16.6828 12.6903 16.4842 12.7421C16.2874 12.7922 16.0709 12.769 15.8812 12.6581H15.8794L12.3635 10.5718C12.2437 10.5038 12.1417 10.4072 12.0701 10.2909C11.9949 10.1692 11.952 10.026 11.952 9.87575V5.22187Z"
                              fill="#F28394"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M4.87932 1.06934C7.57396 1.06934 9.75865 3.25403 9.75865 5.94866C9.75865 8.64329 7.57396 10.828 4.87932 10.828C2.18469 10.8298 0 8.64508 0 5.94866C0 3.25403 2.18469 1.06934 4.87932 1.06934ZM4.35686 7.89717H5.39821V8.82043H4.35686V7.89717ZM5.39821 7.2584H4.35686C4.25308 5.99339 4.03479 5.19001 4.03479 3.925C4.03479 3.458 4.41412 3.08047 4.87932 3.08047C5.34632 3.08047 5.72386 3.45979 5.72386 3.925C5.72565 5.18822 5.50378 5.99339 5.39821 7.2584Z"
                              fill="#D8453E"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1907_105681">
                              <rect
                                width="21.9865"
                                height="18"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>{" "}
                      {stats?.overdue} {t("overdue")}
                    </div>
                  )}{" "}
                </>
              )}
            </>
          )}
        </div>
      </div>
      <div className="course-info-table">
        <table class="table mb-0 office_list table-striped video-list">
          <thead>
            <tr>
              <th className="srno">Sl. No</th>
              <th
                className={`name-tile cursor-pointer is-sort ${
                  isNameAsc ? "selected-sort" : ""
                }`}
                onClick={() => setNameOrder()}
              >
                {heading === "Onboarding" ? "Onboarding Action Path" : heading}
              </th>
              <th
                className={`sta-tile cursor-pointer is-sort ${
                  isStatusAsc ? "selected-sort" : ""
                }`}
                onClick={() => setStatusOrder()}
              >
                {t("Status")}
              </th>
              <th
                className={`is-sort cursor-pointer ${
                  isProgressAsc ? "selected-sort" : ""
                }`}
                onClick={() => setProgressOrder()}
              >
                {t("Progress")} %
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr className="not-found">
                <td colSpan={5}>
                  {[1, 2, 3].map((m) => {
                    return (
                      <ShimmerForProfileTabs key={`notify-${m}-shimmer`} />
                    );
                  })}
                </td>
              </tr>
            ) : !_.isEmpty(profileReports) ? (
              profileReports?.map((item) => {
                return (
                  <tr>
                    <td>{item?.sl_no}</td>
                    <td
                      className={`${
                        isOther === "0" && _.toNumber(item?.course_status) === 1
                          ? "cursor-pointer"
                          : ""
                      } `}
                      title={item?.name}
                      onClick={() =>
                        isOther === "0" && _.toNumber(item?.course_status) === 1
                          ? navigateToDetail(item)
                          : ""
                      }
                    >
                      {isOther === "0" &&
                      _.toNumber(item?.course_status) === 1 ? (
                        <u
                          className="p_wrap "
                          dangerouslySetInnerHTML={{ __html: item?.name }}
                        ></u>
                      ) : (
                        item?.name
                      )}
                    </td>
                    <td>
                      {_.toLower(item?.status) === "overdue"
                        ? "Overdue"
                        : _.toLower(item?.status) === "completed"
                        ? "Completed"
                        : _.toLower(item?.status) === "in-progress"
                        ? "In Progress"
                        : "Yet to start"}
                    </td>
                    <td>
                      <div className="progress-box">
                        <span className="countprogre">{item?.progress}%</span>{" "}
                        <ProgressBar
                          variant={`${
                            _.toLower(item?.status) === "overdue"
                              ? "progress-bar bg-danger"
                              : _.toLower(item?.status) === "completed"
                              ? "progress-bar bg-success"
                              : _.toLower(item?.status) === "in-progress"
                              ? "progress-bar bg-warning"
                              : "progress-bar bg-info"
                          }`}
                          now={item?.progress}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr className="not-found">
                <td colSpan={5}>
                  <NotFoundImage />
                  {/* <img src="/images/finwell-img/NoSearchResults.svg" alt="Not Found" /> */}
                  <p>{t("No Data Found.")}</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContentDetailComponent;